import React from 'react';
import {observer} from 'mobx-react';
import _ from 'lodash';
import ActionLinks from './ActionLinks';
import ModelValue from './ModelValue';

const Row = observer(({
  model,
  columns,
  onEditClicked,
  editRoute,
  onRemoveClicked,
  editModelCaption,
  removeModelCaption,
  showLinks,
  customLinks,
  clickable,
  onClick,
  trait,
  rowStyle,
  ...rest
}) => {
  return (
    <tr className={`TableRow-${trait} ${clickable ? 'clickable' : 'unclickable'}`} onClick={onClick}>
      {columns.map((c, index) => (
        <td key={index} className={`col-${c.width} ${rowStyle} ${c.className|| ''}`}>
          <ModelValue model={model} column={c} rest={rest}/>
        </td>
      ))}
      {showLinks &&
        <td className={`relative right-align ${rowStyle}`}>
          <ActionLinks
            customLinks={customLinks}
            model={model}
            action={editRoute || onEditClicked}
            onRemoveClicked={onRemoveClicked}
            editModelCaption={editModelCaption}
            removeModelCaption={removeModelCaption}
          />
        </td>
      }
    </tr>
  );
});

export default Row;
